"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var schemaTypes_1 = require("../../../shared/types/schemaTypes");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var FileIconComponent_1 = __importDefault(require("../../../shared/components/CrudeComponents/FileIconComponent"));
var CrudeThumbnailComponent = function (props) {
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    // manage Licenses
    var extendedTableLicense = crudeLicense.extendedTable.available;
    var maxThumbnails = extendedTableLicense ? appLayout.maxThumbnails : undefined;
    var _a = react_1.useState([]), thumbnails = _a[0], setThumbnails = _a[1];
    var _b = react_1.useState([]), files = _b[0], setFiles = _b[1];
    var getFiles = function (fileString) {
        var fileVal = [];
        fileVal = fileString.split(',');
        return fileVal;
    };
    react_1.useEffect(function () {
        props.content && setFiles(getFiles(props.content));
    }, [props.content]);
    react_1.useEffect(function () {
        var fileMainType = props.schema.columnSubType ? props.schema.columnSubType : schemaTypes_1.ColumnSubType.Document;
        var maxLength = (maxThumbnails && (maxThumbnails < files.length)) ? maxThumbnails : files.length;
        var template = [];
        var fileCounter = 0;
        // Todo extract file extension
        var fileSubType = undefined; // = ImageType.gif
        files.map(function (element, index) {
            if (fileCounter < maxLength) {
                fileCounter += 1;
                if (props.thumbnails && props.thumbnails[index]) {
                    template.push(react_1.default.createElement("img", { style: { marginRight: '5px' }, src: "data:image;base64, " + props.thumbnails[index] }));
                }
                else {
                    // zunächst aus schema auslesen, später ggf. noch fileExtension / Größe mitgeben
                    template.push(react_1.default.createElement(FileIconComponent_1.default, { fileMainType: fileMainType, fileSubType: fileSubType, width: '24px' }));
                }
            }
        });
        setThumbnails(template);
    }, [props.thumbnails, files]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        thumbnails && thumbnails.map(function (element) {
            return element;
        }),
        maxThumbnails && maxThumbnails < files.length &&
            react_1.default.createElement(react_1.default.Fragment, null, "...")));
};
exports.default = CrudeThumbnailComponent;
